import React from 'react';

export default function FoodIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Bone shape */}
      <path
        d="M17.2 3.5C16.1 2.4 14.3 2.4 13.2 3.5L3.5 13.2C2.4 14.3 2.4 16.1 3.5 17.2C4.1 17.8 4.9 18 5.7 17.9L6.1 18.3C5.9 19.1 6.2 19.9 6.8 20.5C7.9 21.6 9.7 21.6 10.8 20.5L20.5 10.8C21.6 9.7 21.6 7.9 20.5 6.8C19.9 6.2 19.1 5.9 18.3 6.1L17.9 5.7C18 4.9 17.8 4.1 17.2 3.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14.5 9.5L9.5 14.5" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
}
